import { Link } from 'react-router-dom';
import { PRODUCT_BUCKETS } from '../content/products';
import { INDUSTRIES } from '../content/industries';
import { CONTACT } from '../content/site';
import Logo from './Logo';

const colHead = 'font-mono text-[10px] uppercase tracking-[0.3em] text-mute mb-5';
const colLink = 'block py-1.5 text-sm text-dim transition-colors hover:text-white';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer id="footer" className="border-t border-line bg-panel" data-testid="site-footer">
      <div className="mx-auto max-w-shell px-5 py-16 sm:px-8 lg:py-20">
        <div className="flex flex-col gap-10 border-b border-line2 pb-12 lg:flex-row lg:items-start lg:justify-between">
          <div className="text-white">
            <Logo />
            <p className="mt-5 max-w-md text-sm leading-relaxed text-dim">
              RangeSafe Stove Safety Knobs™ are a proactive, effective and ADA-compliant solution to
              reduce the risk of accidental actuation of gas and electric stoves that can lead to
              fires and gas leaks in commercial properties.
            </p>
          </div>
          <div className="flex flex-col gap-1.5 font-mono text-xs text-dim sm:flex-row sm:flex-wrap sm:gap-x-10 sm:gap-y-1.5 lg:flex-col lg:text-right">
            <a href={`mailto:${CONTACT.commercialEmail}`} data-testid="footer-email" className="hover:text-white">
              {CONTACT.commercialEmail}
            </a>
            <a href={CONTACT.phoneHref} data-testid="footer-phone" className="hover:text-white">
              {CONTACT.phone}
            </a>
            <p data-testid="footer-address">
              4583 Highway 903
              <br />
              Bracey, Virginia 23919
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-x-8 gap-y-10 pt-12 sm:grid-cols-3 lg:grid-cols-5">
          <nav aria-label="Company">
            <p className={colHead}>Company</p>
            <Link to="/about" className={colLink} data-testid="footer-about">About RangeSafe</Link>
            <Link to="/how-it-works" className={colLink} data-testid="footer-how">How It Works</Link>
            <Link to="/resources" className={colLink} data-testid="footer-resources">Resources</Link>
            <Link to="/contact" className={colLink} data-testid="footer-contact">Contact Commercial Solutions Team</Link>
          </nav>

          <nav aria-label="Products">
            <p className={colHead}>Products</p>
            {PRODUCT_BUCKETS.map((b) => (
              <Link
                key={b.name}
                to={`/products#${b.name.toLowerCase()}`}
                className={colLink}
                data-testid={`footer-product-${b.name.toLowerCase()}`}
              >
                {b.name}
              </Link>
            ))}
          </nav>

          <nav aria-label="Industries">
            <p className={colHead}>Industries</p>
            {INDUSTRIES.map((i) => (
              <Link key={i.slug} to={`/industries/${i.slug}`} className={colLink} data-testid={`footer-industry-${i.slug}`}>
                {i.name}
              </Link>
            ))}
            <Link to="/manufacturers" className={colLink} data-testid="footer-oem">
              Manufacturers &amp; OEM
            </Link>
          </nav>

          <nav aria-label="Support">
            <p className={colHead}>Support</p>
            <Link to="/resources#installation" className={colLink} data-testid="footer-installation">Installation &amp; Care</Link>
            <Link to="/warranty" className={colLink} data-testid="footer-warranty">Warranty Information</Link>
          </nav>

          <nav aria-label="Legal">
            <p className={colHead}>Legal</p>
            <Link to="/privacy" className={colLink} data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className={colLink} data-testid="footer-terms">Terms of Service</Link>
            <Link to="/cookies" className={colLink} data-testid="footer-cookies">Cookie Policy</Link>
            <Link to="/cookie-preferences" className={colLink} data-testid="footer-cookie-preferences">Cookie Preferences</Link>
            <Link to="/accessibility" className={colLink} data-testid="footer-accessibility">Accessibility</Link>
          </nav>
        </div>

        <div className="mt-16 border-t border-line2 pt-8 font-mono text-[10px] uppercase tracking-[0.18em] text-mute">
          <p>© {year} RangeSafe · RangeSafe Stove Safety Knobs™</p>
        </div>
      </div>
    </footer>
  );
}
